import React, { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import MModal from '@components/common/m-modal/MModal';
import Spinner from '@components/common/spinner/spinner';

import { setUser } from '@reducers/userSlice';
import { logOut, setIsAuth, setIsAuthLoading } from '@reducers/authSlice';
import { setIsError } from '@reducers/notificationSlice';

import { userRoleOptions } from '@models/users';

import { useLazyGetUserViewQuery } from '@api/UserApi/userView';
import { roles } from '@models/auth';
import { useLogoutMutation } from '@api/AuthApi/authService';

const ChooseRoleModal = ({
                             isChooseRoleModal,
                             setIsChooseRoleModal,
                             isAuth = true,
                             isInitialLogin = false,
                             callback = () => {
                             }
                         }) => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const myRoles = useSelector(state => state.user.roles);
    const username = useSelector(state => state.user.username);
    const token = useSelector(state=>state.auth.token);

    const [logout] = useLogoutMutation();

    const fetchLogout = async () => {
        try {
            await logout({access_token: token}).unwrap();
            dispatch(logOut());
        } catch (error) {
            console.log('error')
            dispatch(setIsError('Ошибка logout'));
        } finally {
            console.log('closed')
        }
    }
    const [isLoading, setIsLoading] = useState(false);
    const [getUserInfo] = useLazyGetUserViewQuery();
    const dispatch = useDispatch();
    const handleRoleSelect = async (option) => {
        setIsLoading(true)
        const user = await getUserInfo({ username, role: option.value }, {preferCacheValue: true});
        if (user.error) {
            dispatch(setIsError(t(`general.models.serverErrors.UView.${user.error.data?.error_code}`, `${user.error.data?.error_code}: ${user.error.data?.message}`)));
        } else {
            callback(option.value);
            dispatch(setUser({ ...user.data.user, activeRole: option.value }));
            dispatch(setIsAuthLoading(false));
            localStorage.setItem('user', JSON.stringify({ ...user.data.user, activeRole: option.value }));
            if (!isAuth) {
                dispatch(setIsAuth(true));
            }
            navigate(roles[option.value])
        }
        setIsLoading(false)
        setIsChooseRoleModal(false);
    };
    const onHandleCancelButton = async () => {
        if(isInitialLogin) {
            await fetchLogout();
        }
        setIsChooseRoleModal(false)
    }

    return (
      <MModal
        active={isChooseRoleModal}
        setActive={setIsChooseRoleModal}
        onCloseModal={()=>{
            if (isInitialLogin) {
                fetchLogout()
            }
        }}
      >
          <Spinner spinning={isLoading}>
              <div className='flex flex-col w-96'>
                  <h5 className='text-xl font-semibold mx-auto my-3 mb-8'>
                      {t('general.header.chooseRoleModal.title')}
                  </h5>
                  {userRoleOptions.filter((option) => myRoles?.includes(option.value))?.map(option => (
                    <p key={option.value}
                       className='font-medium text-base text-center border-solid border-2 mb-4 rounded-lg p-2 cursor-pointer'
                       onClick={() => handleRoleSelect(option)}
                    >
                        {t(`general.header.chooseRoleModal.roles.${option.value}`)}
                    </p>
                  ))}
                  <p
                    className='font-medium text-sm text-center text-main-color mt-6 cursor-pointer'
                    onClick={onHandleCancelButton}
                  >
                      {t('general.header.chooseRoleModal.cancel')}
                  </p>
              </div>
          </Spinner>
      </MModal>
    );
};
export default memo(ChooseRoleModal);
